<div class="row h-100" data-cy="io-pane-container">
  <!-- Actual Pane View -->
  <div class="col-5 h-100 overflow-auto" data-cy="io-pane-detail-panel">
    @if (selectedDocument) {
      <div data-cy="io-pane-selected-document">
        <app-file-manager-image [fillParentWidth]="true"
          [documentID]="selectedDocument.DocumentID" data-cy="io-pane-detail-image">
        </app-file-manager-image>
        <div class="row" data-cy="io-pane-description-row">
          <div class="col-4 text-right" data-cy="io-pane-description-label">Description</div>
          <div class="col-8" data-cy="io-pane-description-value">{{selectedDocument.Description.trim() === '' ? 'No Description' : selectedDocument.Description}}</div>
        </div>
        <div class="row" data-cy="io-pane-filename-row">
          <div class="col-4 text-right" data-cy="io-pane-filename-label">File Name</div>
          <div class="col-8" data-cy="io-pane-filename-value">{{selectedDocument.DocumentFileName}}</div>
        </div>
        <div class="row" data-cy="io-pane-created-row">
          <div class="col-4 text-right" data-cy="io-pane-created-label">Created</div>
          <div class="col-8" data-cy="io-pane-created-value">{{moment(selectedDocument.DocumentCreateDate).format('MM/DD/YYYY hh:mm A')}}</div>
        </div>
        <div class="row" data-cy="io-pane-modified-row">
          <div class="col-4 text-right" data-cy="io-pane-modified-label">Modified</div>
          <div class="col-8" data-cy="io-pane-modified-value">{{moment(selectedDocument.DocumentModifiedDate).format('MM/DD/YYYY hh:mm A')}}</div>
        </div>
        <div class="row" data-cy="io-pane-categories-row">
          <div class="col-4 text-right" data-cy="io-pane-categories-label">Categories</div>
          <div class="col-8" data-cy="io-pane-categories-value">{{selectedDocument.dataDocumentTags | category}}</div>
        </div>
      </div>
    }
  </div>

  <!-- List of thumbnails -->
  <div class="col-7 h-100 overflow-auto pl-3" style="border-left: 2px solid #00A8FF" data-cy="io-pane-thumbnails-panel">

    @if (images.length !== 0) {
      <div class="d-flex flex-wrap" cdkDropListGroup data-cy="io-pane-thumbnails-container">
        <div cdkDropList [cdkDropListEnterPredicate]="dropListEnterPredicate" (cdkDropListDropped)="dropListDropped($event)" data-cy="io-pane-droplist"></div>
        @for (image of images; track image; let i = $index) {
          <div cdkDropList [cdkDropListEnterPredicate]="dropListEnterPredicate"
            (cdkDropListDropped)="dropListDropped($event)" class="position-relative" data-cy="io-pane-thumbnail-item">
            @if (image.selected) {
              <div class="selected-check" data-cy="io-pane-selected-check">
                <lucide-icon name="check-circle" [size]="20" class="text-success" data-cy="io-pane-check-icon"></lucide-icon>
              </div>
            }
            <div cdkDrag class="document-tile" (cdkDragMoved)="dragMoved($event)"
              [style.width.px]="selectedSize" [style.height.px]="selectedSize"
              (click)="onImageClick($event, image)" (dblclick)="onImageDblClick(image)"
              oncontextmenu="return false;" (contextmenu)="onRightClick.emit({event: $event, object: image,  isTreeNode: false})" data-cy="io-pane-thumbnail">
              <app-file-manager-image [width]="selectedSize" [maxHeight]="selectedSize" [documentID]="image.DocumentID" data-cy="io-pane-thumbnail-image">
              </app-file-manager-image>
            </div>
          </div>
        }
      </div>
    }

  </div>
</div>
